
import apiClient from '../helpers/api_client';

// Roles
export const getAllRoles = (page = 0, size = 10) =>
  apiClient.get('/roles', { params: { page, size, sort: 'createdAt,desc' } });
export const getRole = (id) => apiClient.get(`/roles/${id}`);
export const createRole = (data) => apiClient.post('/roles', data);
export const updateRole = (id, data) => apiClient.put(`/roles/${id}`, data);
export const deleteRole = (id) => apiClient.delete(`/roles/${id}`);

// Clients
export const getAllClients = (page = 0, size = 10) =>
  apiClient.get('/clients', { params: { page, size, sort: 'createdAt,desc' } });
export const getClient = (id) => apiClient.get(`/clients/${id}`);
export const createClient = (data) => apiClient.post('/clients', data);
export const updateClient = (id, data) => apiClient.put(`/clients/${id}`, data);
export const deleteClient = (id) => apiClient.delete(`/clients/${id}`);

// Companies
export const getAllCompanies = (page = 0, size = 10) =>
  apiClient.get('/companies', { params: { page, size, sort: 'createdAt,desc' } });
export const getCompany = (id) => apiClient.get(`/companies/${id}`);
export const createCompany = (data) => apiClient.post('/companies', data);
export const updateCompany = (id, data) => apiClient.put(`/companies/${id}`, data);
export const deleteCompany = (id) => apiClient.delete(`/companies/${id}`);

// Regions
export const getAllRegions = (page = 0, size = 10) =>
  apiClient.get('/regions', { params: { page, size, sort: 'createdAt,desc' } });
export const getRegion = (id) => apiClient.get(`/regions/${id}`);
export const createRegion = (data) => apiClient.post('/regions', data);
export const uploadRegions = (formData) =>
  apiClient.post('/regions/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateRegion = (id, data) => apiClient.put(`/regions/${id}`, data);
export const deleteRegion = (id) => apiClient.delete(`/regions/${id}`);

// Districts
export const getAllDistricts = (page = 0, size = 10) =>
  apiClient.get('/districts', { params: { page, size, sort: 'createdAt,desc' } });
export const getDistrict = (id) => apiClient.get(`/districts/${id}`);
export const createDistrict = (data) => apiClient.post('/districts', data);
export const uploadDistricts = (formData) =>
  apiClient.post('/districts/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateDistrict = (id, data) => apiClient.put(`/districts/${id}`, data);
export const deleteDistrict = (id) => apiClient.delete(`/districts/${id}`);

// =====================
// Users
// =====================

export const getAllUsers = (page = 0, size = 10) =>
  apiClient.get('/users', { params: { page, size, sort: 'createdAt,desc' } });

export const getUser = (id) => apiClient.get(`/users/${id}`);

export const createUser = (data) => apiClient.post('/users/register', data);

export const updateUser = (id, data) => apiClient.put(`/users/${id}`, data);

export const deleteUser = (id) => apiClient.delete(`/users/${id}`);

export const resetUser = (id, data = {}) =>
  apiClient.put(`/users/reset/${id}`, data);

export const blockActivateUser = (id) =>
  apiClient.put(`/users/block-activate/${id}`);

export const changeUserPassword = (id, { password }) =>
  apiClient.put(`/users/change-password/${id}`, { password });

// 🔍 Lookup user by identifiers (NIN, TIN, or Certificate Number)
export const lookupUserByIdentifier = ({ nin, tin, certificate_number }) => {
  const params = {};
  if (nin) params.nin = nin;
  if (tin) params.tin = tin;
  if (certificate_number) params.certificate_number = certificate_number;
  return apiClient.get('/users/lookup', { params });
};

// 🔹 Get all valuers or non-valuers (filter by is_valuer)
export const getAllValuers = (is_valuer = true) =>
  apiClient.get('/users/valuers', { params: { is_valuer } });

// 🔹 Request OTP for password reset
export const requestUserOtp = (data) =>
  apiClient.post('/users/reset-password/request', data);

// 🔹 Verify OTP code
export const verifyUserOtp = (data) =>
  apiClient.post('/users/reset-password/verify', data);

// 🔹 Confirm password reset after OTP verification
export const confirmUserResetPassword = (data) =>
  apiClient.post('/users/reset-password/confirm', data);


// Councils
export const getAllCouncils = (page = 0, size = 10) =>
  apiClient.get('/councils', { params: { page, size, sort: 'createdAt,desc' } });
export const getCouncil = (id) => apiClient.get(`/councils/${id}`);
export const createCouncil = (data) => apiClient.post('/councils', data);
export const uploadCouncils = (formData) =>
  apiClient.post('/councils/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateCouncil = (id, data) => apiClient.put(`/councils/${id}`, data);
export const deleteCouncil = (id) => apiClient.delete(`/councils/${id}`);

// Wards
export const getAllWards = (page = 0, size = 10) =>
  apiClient.get('/wards', { params: { page, size, sort: 'createdAt,desc' } });
export const getWard = (id) => apiClient.get(`/wards/${id}`);
export const createWard = (data) => apiClient.post('/wards', data);
export const uploadWards = (formData) =>
  apiClient.post('/wards/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateWard = (id, data) => apiClient.put(`/wards/${id}`, data);
export const deleteWard = (id) => apiClient.delete(`/wards/${id}`);
export const mergeWards = (data) => apiClient.post('/wards/merge', data);

// Project categories
export const getAllProjectCategories = (page = 0, size = 10) =>
  apiClient.get('/project-categories', { params: { page, size, sort: 'createdAt,desc' } });
export const getProjectCategory = (id) => apiClient.get(`/project-categories/${id}`);
export const createProjectCategory = (data) => apiClient.post('/project-categories', data);
export const updateProjectCategory = (id, data) => apiClient.put(`/project-categories/${id}`, data);
export const deleteProjectCategory = (id) => apiClient.delete(`/project-categories/${id}`);

// Projects
export const getAllProjects = (page = 0, size = 10) =>
  apiClient.get('/projects', { params: { page, size, sort: 'createdAt,desc' } });
export const getProject = (id) => apiClient.get(`/projects/${id}`);
export const createProject = (data) => apiClient.post('/projects', data);
export const updateProject = (id, data) => apiClient.put(`/projects/${id}`, data);
export const deleteProject = (id) => apiClient.delete(`/projects/${id}`);

// Project-User Mapping
export const getAllMappedUsers = (page = 0, size = 10) =>
  apiClient.get('/project-users', { params: { page, size, sort: 'createdAt,desc' } });
export const getMappedUser = (id) => apiClient.get(`/project-users/${id}`);
export const createMappedUser = ({ userId, projectId, isCurrent = false }) =>
  apiClient.post(`/project-users/map?userId=${userId}&projectId=${projectId}&isCurrent=${isCurrent}`);
export const deleteMappedUser = (id) => apiClient.delete(`/project-users/${id}`);
export const getUserProjects = (userId) => apiClient.get(`/project-users/user/${userId}/projects`);

// Permissions
export const getAllPermissions = (page = 0, size = 10) =>
  apiClient.get('/permissions', {
    params: { page, size, sort: 'createdAt,desc' }
  });

export const getPermissionById = (id) =>
  apiClient.get(`/permissions/${id}`);

export const getPermissionsByController = (controller) =>
  apiClient.get(`/permissions/controller/${controller}`);

export const getPermissionsByCategory = (category) =>
  apiClient.get(`/permissions/category/${category}`);

export const createPermission = (data) =>
  apiClient.post('/permissions', data);

export const updatePermission = (id, data) =>
  apiClient.put(`/permissions/${id}`, data);

export const deletePermissionById = (id) =>
  apiClient.delete(`/permissions/${id}`);

export const refreshPermissions = () =>
  apiClient.post("/permissions/refresh");


// Mortgage Valuations
export const getAllMortgageValuations = (
  { projectId, clientId, status, startDate, endDate, page = 0, size = 10 } = {}
) =>
  apiClient.get('/mortgage-valuations', {
    params: {
      projectId,
      clientId,
      status,
      startDate,
      endDate,
      page,
      size,
      sort: 'createdAt,desc'
    }
  });

export const getMortgageValuation = (id) =>
  apiClient.get(`/mortgage-valuations/${id}`);

export const createMortgageValuation = (data) =>
  apiClient.post('/mortgage-valuations', data);

export const updateMortgageValuation = (id, data) =>
  apiClient.put(`/mortgage-valuations/${id}`, data);

export const patchMortgageValuation = (id, data) =>
  apiClient.patch(`/mortgage-valuations/${id}`, data);

export const deleteMortgageValuation = (id) =>
  apiClient.delete(`/mortgage-valuations/${id}`);

export const attachPropertyToMortgageValuation = (id, propertyData) =>
  apiClient.put(`/mortgage-valuations/attach-property/${id}`, propertyData);

// =====================
// Asset Valuations
// =====================

export const getAllAssetValuations = (
  { projectId, clientId, status, startDate, endDate, page = 0, size = 10 } = {}
) =>
  apiClient.get('/asset-valuations', {
    params: {
      projectId,
      clientId,
      status,
      startDate,
      endDate,
      page,
      size,
      sort: 'createdAt,desc'
    }
  });

export const getAssetValuation = (id) =>
  apiClient.get(`/asset-valuations/${id}`);

export const createAssetValuation = (data) =>
  apiClient.post('/asset-valuations', data);

export const updateAssetValuation = (id, data) =>
  apiClient.put(`/asset-valuations/${id}`, data);

export const patchAssetValuation = (id, data) =>
  apiClient.patch(`/asset-valuations/${id}`, data);

export const deleteAssetValuation = (id) =>
  apiClient.delete(`/asset-valuations/${id}`);

// 📦 Asset APIs
// Base: /assets

// Get all assets (paginated)
export const getAllAssets = (page = 0, size = 10, sort = 'createdAt,desc') =>
  apiClient.get('/assets', {
    params: { page, size, sort },
  });

// Get a single asset by ID
export const getAsset = (id) => apiClient.get(`/assets/${id}`);

// Create a new asset
export const createAsset = (data) => apiClient.post('/assets', data);

// ---------------------------------------------------------------------------
// Asset Excel import (dedicated API: FURN / ICT / EQP survey workbooks)
// ---------------------------------------------------------------------------

/** Categories currently supported by POST /asset-imports */
export const getAssetImportSupportedCategories = () =>
  apiClient.get('/asset-imports/supported-categories', { suppressGlobalError: true });

/**
 * Download blank import template for a category (.xlsx blob).
 * @param {string} assetCategoryCode e.g. "FURN" | "ICT" | "EQP"
 */
export const downloadAssetImportTemplate = (assetCategoryCode) =>
  apiClient.get('/asset-imports/template', {
    params: { assetCategoryCode },
    responseType: 'blob',
    suppressGlobalError: true,
  });

/**
 * Import assets from survey Excel into an existing valuation.
 * Default dryRun=true (preview only).
 * Expected files: FURNITURE 1/2 (FURN), ICT A/B (ICT), EQUIPMENT (EQP).
 */
export const importAssetsFromExcel = ({
  file,
  assetCategoryCode,
  assetValuationId,
  valuerId,
  dryRun = true,
  allowPartial = false,
}) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('assetCategoryCode', assetCategoryCode);
  formData.append('assetValuationId', assetValuationId);
  formData.append('valuerId', valuerId);
  formData.append('dryRun', String(!!dryRun));
  formData.append('allowPartial', String(!!allowPartial));
  return apiClient.post('/asset-imports', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    suppressGlobalError: true,
  });
};

// Update an existing asset
export const updateAsset = (id, data) => apiClient.put(`/assets/${id}`, data);

// Update asset using Flutter-compatible multipart payload:
// - data: JSON string
// - barcode_image: optional file
export const updateAssetMultipart = (id, data, barcodeImageFile = null) => {
  const blockedKeys = new Set([
    "is_reviewed",
    "isReviewed",
  ]);

  const sanitizedData = Object.fromEntries(
    Object.entries(data || {}).filter(([key, value]) => {
      if (blockedKeys.has(key)) return false;
      if (value === undefined) return false;
      return true;
    })
  );

  const formData = new FormData();
  formData.append("data", JSON.stringify(sanitizedData));

  if (barcodeImageFile) {
    formData.append("barcode_image", barcodeImageFile);
  }

  return apiClient.put(`/assets/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const reviewAsset = (assetId) =>
  apiClient.put(`/assets/${assetId}/review`);

export const markAssetReviewNotCompleted = (assetId, data) =>
  apiClient.put(`/assets/${assetId}/review-not-completed`, data);

export const clearAssetReviewNotCompletedRemark = (assetId) =>
  apiClient.patch(`/assets/${assetId}/review-not-completed/clear-remark`);

export const unreviewAsset = (assetId) =>
  apiClient.put(`/assets/${assetId}/unreview`);

// Delete an asset
export const deleteAsset = (id) => apiClient.delete(`/assets/${id}`);

export const getDeletedAssets = ({
  categoryCode,
  page = 0,
  size = 10,
} = {}) =>
  apiClient.get('/assets/deleted', {
    params: {
      page,
      size,
      ...(categoryCode ? { categoryCode } : {}),
    },
  });

export const restoreAsset = (id) => apiClient.patch(`/assets/${id}/restore`);

// 🔍 Search assets by name, valuation ref, valuer, and/or condition
export const searchAssets = ({
  search,
  name,
  description,
  otherName,
  valuationRef,
  valuer,
  institutionName,
  wardIds,
  condition,
  categoryCode,
  reviewed,
  reviewNotCompleted,
  reviewRemarkIssue,
  sort,
  page = 0,
  size = 10,
} = {}) => {
  const params = { page, size };
  if (search) params.search = search;
  if (name) params.name = name;
  if (description) params.description = description;
  if (otherName) params.otherName = otherName;
  if (valuationRef) params.valuationRef = valuationRef;
  if (valuer) params.valuer = valuer;
  if (institutionName) params.institutionName = institutionName;
  if (wardIds && wardIds.length > 0) params.wardIds = wardIds.join(',');
  if (condition) params.condition = condition;
  if (categoryCode) params.categoryCode = categoryCode;
  if (reviewed !== undefined) params.reviewed = reviewed;
  if (reviewNotCompleted !== undefined) params.reviewNotCompleted = reviewNotCompleted;
  if (reviewRemarkIssue !== undefined) params.reviewRemarkIssue = reviewRemarkIssue;
  if (sort) params.sort = sort;

  if (!Object.keys(params).some((key) => !["page", "size", "sort"].includes(key))) {
    throw new Error("At least one asset search filter is required");
  }

  return apiClient.get(`/assets/search`, { params });
};


// ✅ Check if an asset exists by barcode
export const checkAssetByBarcode = (barcode) =>
  apiClient.get(`/assets/exists/barcode/${barcode}`);

// ✅ Get assets linked to a specific valuation
export const getAssetsByValuation = (assetValuationId) =>
  apiClient.get(`/assets/by-valuation/${assetValuationId}`);

// ✅ Get assets by category code (e.g., "ICT", "FURN", "BLDG") - all valuations (paginated)
export const getAssetsByCategoryCode = (categoryCode, page = 0, size = 10) =>
  apiClient.get(`/assets/by-category-code/${categoryCode}`, {
    params: { page, size }
  });

// ✅ Get assets by category filter with same response shape as GET /assets
export const getAssetsByCategory = ({
  assetCategoryId,
  assetCategoryCode,
  reviewed,
  reviewNotCompleted,
  reviewRemarkIssue,
  sort,
  page = 0,
  size = 10,
}) => {
  const params = { page, size };
  if (assetCategoryId) params.assetCategoryId = assetCategoryId;
  if (assetCategoryCode) params.assetCategoryCode = assetCategoryCode;
  if (reviewed !== undefined) params.reviewed = reviewed;
  if (reviewNotCompleted !== undefined) params.reviewNotCompleted = reviewNotCompleted;
  if (reviewRemarkIssue !== undefined) params.reviewRemarkIssue = reviewRemarkIssue;
  if (sort) params.sort = sort;
  return apiClient.get('/assets/by-category', { params }).catch((error) => {
    // Backward compatibility: older backend may not have /assets/by-category yet.
    if (error?.response?.status === 404 && assetCategoryCode) {
      return apiClient.get(`/assets/by-category-code/${assetCategoryCode}`, {
        params: { page, size },
      }).catch((nestedError) => {
        // Last-resort compatibility: if both category endpoints are missing,
        // fetch the page from /assets and filter client-side.
        if (nestedError?.response?.status === 404) {
          return getAllAssets(page, size).then((response) => {
            const result = response?.data?.data || response?.data || {};
            const content = Array.isArray(result?.content) ? result.content : [];
            const wantedCode = String(assetCategoryCode || "").toUpperCase();
            const filtered = content.filter((asset) => {
              const code = String(
                asset?.asset_category?.code ||
                asset?.assetCategory?.code ||
                asset?.category?.code ||
                asset?.asset_category_code ||
                asset?.category_code ||
                ""
              ).toUpperCase();
              return code === wantedCode;
            });

            return {
              ...response,
              data: {
                ...(response?.data || {}),
                data: {
                  ...result,
                  content: filtered,
                },
              },
            };
          });
        }
        throw nestedError;
      });
    }
    throw error;
  });
};

export const getAstAssetNameCategoriesByAssetCategory = (assetCategoryId) =>
  apiClient.get(`/ast-asset-name-categories/by-asset-category/${assetCategoryId}`, {
    skipAuth: true,
  });

export const getAstAssetObservedConditions = () =>
  apiClient.get('/ast-asset-observed-conditions', {
    params: { page: 0, size: 1000 },
  });

export const getAstBuildingTypes = (page = 0, size = 1000) =>
  apiClient.get('/ast-building-types', {
    params: { page, size },
  });

export const getAstInstitutionCategories = (page = 0, size = 1000) =>
  apiClient.get('/ast-institution-categories', {
    params: { page, size },
  });

export const getAstInstitutionCategory = (id) =>
  apiClient.get(`/ast-institution-categories/${id}`);

export const createAstInstitutionCategory = (data) =>
  apiClient.post('/ast-institution-categories', data);

export const updateAstInstitutionCategory = (id, data) =>
  apiClient.put(`/ast-institution-categories/${id}`, data);

export const deleteAstInstitutionCategory = (id) =>
  apiClient.delete(`/ast-institution-categories/${id}`);

export const getAstInstitutionsByCategory = (categoryId) =>
  apiClient.get(`/ast-institutions/category/${categoryId}`);

export const getAstInstitutions = (page = 0, size = 1000) =>
  apiClient.get('/ast-institutions', {
    params: { page, size },
  });

export const getAstInstitution = (id) =>
  apiClient.get(`/ast-institutions/${id}`);

export const searchAstInstitutions = (name) =>
  apiClient.get('/ast-institutions/search', { params: { name } });

export const createAstInstitution = (data) =>
  apiClient.post('/ast-institutions', data);

export const updateAstInstitution = (id, data) =>
  apiClient.put(`/ast-institutions/${id}`, data);

export const deleteAstInstitution = (id) =>
  apiClient.delete(`/ast-institutions/${id}`);

export const getAllAstInstitutions = async (size = 1000) => {
  const firstResponse = await getAstInstitutions(0, size);
  const firstData = firstResponse?.data?.data ?? firstResponse?.data ?? {};
  const firstContent = Array.isArray(firstData) ? firstData : (firstData.content || []);
  const totalPages = Number(firstData.totalPages ?? firstData.total_pages ?? 1);

  if (!Number.isFinite(totalPages) || totalPages <= 1) {
    return firstContent;
  }

  const remainingResponses = await Promise.all(
    Array.from({ length: totalPages - 1 }, (_, index) => getAstInstitutions(index + 1, size))
  );

  return remainingResponses.reduce((items, response) => {
    const data = response?.data?.data ?? response?.data ?? {};
    const content = Array.isArray(data) ? data : (data.content || []);
    return items.concat(content);
  }, firstContent);
};

export const getAstInstitutionBuildings = (institutionId) =>
  apiClient
    .get(`/ast-institutions/institution-buildings/${institutionId}`)
    .catch(() => apiClient.get(`/ast-institution-buildings/${institutionId}`));

export const getAllAstInstitutionBuildings = (page = 0, size = 100000) =>
  apiClient.get('/ast-institution-buildings', {
    params: { page, size },
  });

export const getBuildingUses = (page = 0, size = 1000) =>
  apiClient.get('/building-uses', {
    params: { page, size },
  });

export const getAstAssetCategories = (page = 0, size = 1000) =>
  apiClient.get('/ast-categories', {
    params: { page, size },
  });

export const getAssetCategories = getAstAssetCategories;

export const getAstCategory = (id) =>
  apiClient.get(`/ast-categories/${id}`);

export const createAstCategory = (data) =>
  apiClient.post('/ast-categories', data);

export const updateAstCategory = (id, data) =>
  apiClient.put(`/ast-categories/${id}`, data);

export const deleteAstCategory = (id) =>
  apiClient.delete(`/ast-categories/${id}`);

export const getAllAstAssetNameCategories = (page = 0, size = 1000) =>
  apiClient.get('/ast-asset-name-categories', {
    params: { page, size },
  });

export const createAstAssetNameCategory = (data) =>
  apiClient.post('/ast-asset-name-categories', data);

export const updateAstAssetNameCategory = (id, data) =>
  apiClient.put(`/ast-asset-name-categories/${id}`, data);

export const deleteAstAssetNameCategory = (id) =>
  apiClient.delete(`/ast-asset-name-categories/${id}`);

export const getAstAssetNameCategoriesByCategory = (assetCategoryId) =>
  apiClient.get(`/ast-asset-name-categories/by-asset-category/${assetCategoryId}`);

export const getWardsByCouncil = (councilId) => {
  if (!councilId) {
    return Promise.resolve({ data: { data: [] } });
  }

  return apiClient.get(
    `/wards/councils/${councilId}/wards`,
    {
      params: { page: 0, size: 1000 },
    }
  );
};

// ✅ Get site works (paginated)
// ✅ Get all site works with details (optimized query)
export const getAllSiteWorksWithDetails = () =>
  apiClient.get('/site-works/with-details');

export const getSiteWorks = (page = 0, size = 10, assetId = null, valuationId = null, siteWorkType = null, condition = null) =>
  apiClient.get('/site-works', {
    params: { 
      page, 
      size,
      ...(assetId && { assetId }),
      ...(valuationId && { valuationId }),
      ...(siteWorkType && { siteWorkType }),
      ...(condition && { condition })
    }
  });

export const createSiteWork = (data) =>
  apiClient.post('/site-works', data);

export const updateSiteWork = (id, data) =>
  apiClient.put(`/site-works/${id}`, data);

export const deleteSiteWork = (id) =>
  apiClient.delete(`/site-works/${id}`);

export const getSiteWorkPhotosBySiteWork = (siteWorkId) =>
  apiClient.get(`/site-work-photos/by-site-work/${siteWorkId}`);

export const createSiteWorkPhoto = (data) =>
  apiClient.post('/site-work-photos', data);

export const updateSiteWorkPhoto = (id, data) =>
  apiClient.put(`/site-work-photos/${id}`, data);

export const deleteSiteWorkPhoto = (id) =>
  apiClient.delete(`/site-work-photos/${id}`);

// ✅ Get all equipment (paginated) - using category code
export const getAllEquipments = (page = 0, size = 10) =>
  apiClient.get('/assets/by-category-code/EQP', {
    params: { page, size }
  });

// ✅ Get all furniture (paginated) - using category code
export const getAllFurniture = (page = 0, size = 10) =>
  apiClient.get('/assets/by-category-code/FURN', {
    params: { page, size }
  });

// ✅ Get all ICT (paginated) - using category code
export const getAllICT = (page = 0, size = 10) =>
  apiClient.get('/assets/by-category-code/ICT', {
    params: { page, size }
  });

// ✅ Get all land (paginated) - using category code
export const getAllLand = (page = 0, size = 10) =>
  apiClient.get('/assets/by-category-code/LAND', {
    params: { page, size }
  });

// ✅ Get all machinery (paginated) - using category code
export const getAllMachinery = (page = 0, size = 10) =>
  apiClient.get('/assets/by-category-code/MACH', {
    params: { page, size }
  });

// ✅ Get all infrastructure (paginated) - using category code
export const getAllInfrastructure = (page = 0, size = 10) =>
  apiClient.get('/assets/by-category-code/INFR', {
    params: { page, size }
  });

// ✅ Get all vehicles (paginated) - using category code
export const getAllVehicles = (page = 0, size = 10) =>
  apiClient.get('/assets/by-category-code/VEH', {
    params: { page, size }
  });



// Owners
export const getAllOwners = (page = 0, size = 10) =>
  apiClient.get('/owners', { params: { page, size, sort: 'createdAt,desc' } });

export const getOwner = (id) =>
  apiClient.get(`/owners/${id}`);

export const createOwner = (data) =>
  apiClient.post('/owners', data);

export const updateOwner = (id, data) =>
  apiClient.put(`/owners/${id}`, data);

export const deleteOwner = (id) =>
  apiClient.delete(`/owners/${id}`);

// check existence by phone number
export const ownerExistsByPhone = (phoneNumber) =>
  apiClient.get(`/owners/exists/phone/${phoneNumber}`);

// check existence by ID number
export const ownerExistsByIdNumber = (idNumber) =>
  apiClient.get(`/owners/exists/id-number/${idNumber}`);

// get owners linked to a specific mortgage valuation
export const getOwnersByValuation = (mortgageValuationId) =>
  apiClient.get(`/owners/by-valuation/${mortgageValuationId}`);



// Properties
export const getAllProperties = (page = 0, size = 10) =>
  apiClient.get('/properties', { params: { page, size, sort: 'createdAt,desc' } });

export const getProperty = (id) =>
  apiClient.get(`/properties/${id}`);

export const createProperty = (data) =>
  apiClient.post('/properties', data);

export const updateProperty = (id, data) =>
  apiClient.put(`/properties/${id}`, data);

export const deleteProperty = (id) =>
  apiClient.delete(`/properties/${id}`);

// Get properties by owner
export const getPropertiesByOwner = (ownerId) =>
  apiClient.get(`/properties/by-owner/${ownerId}`);

// Get properties by valuation
export const getPropertiesByValuation = (valuationId) =>
  apiClient.get(`/properties/by-valuation/${valuationId}`);

// Buildings
export const getAllBuildings = (page = 0, size = 10) =>
  apiClient.get('/asset-buildings', { params: { page, size, sort: 'createdAt,desc' } });

// Get all buildings with detailed information (optimized native SQL query)
export const getAllBuildingsWithDetails = () =>
  apiClient.get('/asset-buildings/with-details');

// Get asset-buildings by filters (assetId, valuationId, etc.)
export const getAssetBuildings = ({
  assetId = null,
  valuationId = null,
  buildingTypeId = null,
  isPrimary = null,
  page = 0,
  size = 100,
} = {}) =>
  apiClient.get('/asset-buildings', {
    params: {
      page,
      size,
      ...(assetId && { assetId }),
      ...(valuationId && { valuationId }),
      ...(buildingTypeId && { buildingTypeId }),
      ...(isPrimary !== null && isPrimary !== undefined && { isPrimary }),
    },
  });

export const createAssetBuildingMultipart = (formData) =>
  apiClient.post('/asset-buildings', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const updateAssetBuildingMultipart = (id, formData) =>
  apiClient.put(`/asset-buildings/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const deleteAssetBuilding = (id) =>
  apiClient.delete(`/asset-buildings/${id}`);

// Asset Security Overview
export const getAssetSecurityOverviews = ({
  assetId = null,
  assetValuationId = null,
  page = 0,
  size = 100,
} = {}) =>
  apiClient.get('/asset-security-overviews', {
    params: {
      page,
      size,
      ...(assetId && { assetId }),
      ...(assetValuationId && { assetValuationId }),
    },
  });

export const createAssetSecurityOverview = (data) =>
  apiClient.post('/asset-security-overviews', data);

export const updateAssetSecurityOverview = (id, data) =>
  apiClient.put(`/asset-security-overviews/${id}`, data);

// Asset Building Constructions (Step 2.1.2b)
export const getAssetBuildingConstructions = ({
  assetValuationId = null,
  buildingId = null,
  page = 0,
  size = 100,
} = {}) =>
  apiClient.get('/asset-building-constructions', {
    params: {
      page,
      size,
      ...(assetValuationId && { assetValuationId }),
      ...(buildingId && { buildingId }),
    },
  });

export const createAssetBuildingConstruction = (data) =>
  apiClient.post('/asset-building-constructions', data);

export const updateAssetBuildingConstruction = (id, data) =>
  apiClient.put(`/asset-building-constructions/${id}`, data);

// Asset Building Accommodations (Step 2.1.2d)
export const getAssetBuildingAccommodations = ({
  assetValuationId = null,
  buildingId = null,
  page = 0,
  size = 200,
} = {}) =>
  apiClient.get('/asset-building-accommodations', {
    params: {
      page,
      size,
      ...(assetValuationId && { assetValuationId }),
      ...(buildingId && { buildingId }),
    },
  });

export const getAssetBuildingAccommodationsByBuildingAndFloor = ({
  buildingId,
  floor,
} = {}) =>
  apiClient.get('/asset-building-accommodations/by-building-and-floor', {
    params: {
      ...(buildingId && { buildingId }),
      ...(floor && { floor }),
    },
  });

export const createAssetBuildingAccommodations = (data) =>
  apiClient.post('/asset-building-accommodations', data);

export const updateAssetBuildingAccommodations = (data) =>
  apiClient.put('/asset-building-accommodations', data);

export const deleteAssetBuildingAccommodation = (id) =>
  apiClient.delete(`/asset-building-accommodations/${id}`);

export const getBuilding = (id) =>
  apiClient.get(`/buildings/${id}`);

export const createBuilding = (data) =>
  apiClient.post('/buildings', data);

export const updateBuilding = (id, data) =>
  apiClient.put(`/buildings/${id}`, data);

export const deleteBuilding = (id) =>
  apiClient.delete(`/buildings/${id}`);

// Get buildings by owner
export const getBuildingsByOwner = (ownerId) =>
  apiClient.get(`/buildings/by-owner/${ownerId}`);

// Get buildings by valuation
export const getBuildingsByValuation = (valuationId) =>
  apiClient.get(`/buildings/valuation/${valuationId}`);

// =====================
// Features
// =====================

// Get all features (paginated)
export const getAllFeatures = (page = 0, size = 10) =>
  apiClient.get('/features', { params: { page, size, sort: 'createdAt,desc' } });

// Get feature by ID
export const getFeature = (id) =>
  apiClient.get(`/features/${id}`);

// Create new feature
export const createFeature = (data) =>
  apiClient.post('/features', data);

// Update feature
export const updateFeature = (id, data) =>
  apiClient.put(`/features/${id}`, data);

// Delete feature
export const deleteFeature = (id) =>
  apiClient.delete(`/features/${id}`);

// Get features by valuation
export const getFeaturesByValuation = (valuationId) =>
  apiClient.get(`/features/valuation/${valuationId}`);


// =====================
// Attachments
// =====================

// Get all attachments (paginated)
export const getAllAttachments = (page = 0, size = 10) =>
  apiClient.get('/attachments', { params: { page, size, sort: 'createdAt,desc' } });

// Get attachment by ID
export const getAttachment = (id) =>
  apiClient.get(`/attachments/${id}`);

// Create new attachment
export const createAttachment = (data) =>
  apiClient.post('/attachments', data);

// Update attachment
export const updateAttachment = (id, data) =>
  apiClient.put(`/attachments/${id}`, data);

// Delete attachment
export const deleteAttachment = (id) =>
  apiClient.delete(`/attachments/${id}`);

// Get attachments by valuation
export const getAttachmentsByValuation = (valuationId) =>
  apiClient.get(`/attachments/valuation/${valuationId}`);


// Get grouped PDF files (including barcode-pdfs category)
export const getBarcodePdfFiles = () =>
  apiClient.get('/files/pdfs');

// =====================
// Asset Photos
// =====================

// Get all asset photos (paginated)
export const getAllAssetPhotos = (page = 0, size = 10, assetId = null, buildingId = null) =>
  apiClient.get('/asset-photos', {
    params: {
      page,
      size,
      ...(assetId && { asset_id: assetId }),
      ...(buildingId && { building_id: buildingId }),
    },
  });

// Get asset photos by asset ID
export const getAssetPhotosByAsset = (assetId) =>
  apiClient.get(`/asset-photos/by-asset/${assetId}`);

// Get asset photos by building ID
export const getAssetPhotosByBuilding = (buildingId, page = 0, size = 100) =>
  apiClient
    .get(`/asset-photos/by-building/${buildingId}`)
    .catch(() =>
      apiClient.get('/asset-photos', {
        params: {
          page,
          size,
          building_id: buildingId,
        },
      })
    );

export const uploadAssetFile = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return apiClient.post('/files/assets/upload', formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const createAssetPhoto = (data) =>
  apiClient.post('/asset-photos', data);

export const updateAssetPhoto = (id, data) =>
  apiClient.put(`/asset-photos/${id}`, data);

// =====================
// Crop Categories
// =====================

export const getAllCropCategories = (page = 0, size = 10) =>
  apiClient.get('/crop-categories', { params: { page, size, sort: 'createdAt,desc' } });

export const getCropCategory = (id) =>
  apiClient.get(`/crop-categories/${id}`);

export const createCropCategory = (data) =>
  apiClient.post('/crop-categories', data);

export const updateCropCategory = (id, data) =>
  apiClient.put(`/crop-categories/${id}`, data);

export const deleteCropCategory = (id) =>
  apiClient.delete(`/crop-categories/${id}`);

// =====================
// Banks
// =====================

export const getAllBanks = (page = 0, size = 10) =>
  apiClient.get('/banks', { params: { page, size } });

export const getBank = (id) =>
  apiClient.get(`/banks/${id}`);

export const createBank = (data) =>
  apiClient.post('/banks', data);

export const updateBank = (id, data) =>
  apiClient.put(`/banks/${id}`, data);

export const deleteBank = (id) =>
  apiClient.delete(`/banks/${id}`);

export const searchBanksByName = (name) =>
  apiClient.get('/banks/search', { params: { name } });

// =====================
// Company Profiles
// =====================

export const getAllCompanyProfiles = (page = 0, size = 10) =>
  apiClient.get('/company-profiles', { params: { page, size } });

export const getCompanyProfile = (id) =>
  apiClient.get(`/company-profiles/${id}`);

const getFirstCompanyProfileFromListResponse = (response) => {
  const page = response?.data?.data || response?.data || {};
  const content = Array.isArray(page?.content) ? page.content : [];
  return content[0] || null;
};

const getFallbackCurrentCompanyProfile = () =>
  getAllCompanyProfiles(0, 1).then((response) => ({
    ...response,
    data: {
      ...(response?.data || {}),
      data: getFirstCompanyProfileFromListResponse(response),
    },
  }));

export const getCurrentCompanyProfile = () =>
  apiClient.get('/company-profile').catch((error) => {
    if (error?.response?.status !== 404) throw error;
    return getFallbackCurrentCompanyProfile();
  });

export const createCompanyProfile = (data) =>
  apiClient.post('/company-profiles', data);

export const createCompanyProfileMultipart = (data, logoImageFile = null) => {
  const formData = new FormData();
  formData.append("data", new Blob([JSON.stringify(data)], { type: "application/json" }));
  if (logoImageFile) {
    formData.append("logo_image", logoImageFile);
  }
  return apiClient.post('/company-profiles', formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateCompanyProfile = (id, data) =>
  apiClient.put(`/company-profiles/${id}`, data);

export const updateCurrentCompanyProfile = (data) =>
  apiClient.put('/company-profile', data).catch(async (error) => {
    if (error?.response?.status !== 404) throw error;
    const fallback = await getFallbackCurrentCompanyProfile();
    const profileId = fallback?.data?.data?.id;
    if (!profileId) {
      return createCompanyProfile(data);
    }
    return updateCompanyProfile(profileId, data);
  });

export const updateCurrentCompanyProfileMultipart = (data, logoImageFile = null) => {
  const formData = new FormData();
  formData.append("data", new Blob([JSON.stringify(data)], { type: "application/json" }));
  if (logoImageFile) {
    formData.append("logo_image", logoImageFile);
  }
  return apiClient.put('/company-profile', formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }).catch(async (error) => {
    if (error?.response?.status !== 404) throw error;
    const fallback = await getFallbackCurrentCompanyProfile();
    const profileId = fallback?.data?.data?.id;
    if (!profileId) {
      return createCompanyProfileMultipart(data, logoImageFile);
    }
    return apiClient.put(`/company-profiles/${profileId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  });
};

export const deleteCompanyProfile = (id) =>
  apiClient.delete(`/company-profiles/${id}`);

export const getCompanyProfileBankAccounts = (companyProfileId) =>
  apiClient.get(`/company-profiles/${companyProfileId}/bank-accounts`);

export const addCompanyProfileBankAccount = (companyProfileId, data) =>
  apiClient.post(`/company-profiles/${companyProfileId}/bank-accounts`, data);

export const updateCompanyProfileBankAccount = (companyProfileId, bankAccountId, data) =>
  apiClient.put(`/company-profiles/${companyProfileId}/bank-accounts/${bankAccountId}`, data);

export const deleteCompanyProfileBankAccount = (companyProfileId, bankAccountId) =>
  apiClient.delete(`/company-profiles/${companyProfileId}/bank-accounts/${bankAccountId}`);

// =====================
// Invoices
// =====================

export const getAllInvoices = (page = 0, size = 10) =>
  apiClient.get('/invoices', { params: { page, size } });

export const getInvoice = (id) =>
  apiClient.get(`/invoices/${id}`);

export const createInvoice = (data) =>
  apiClient.post('/invoices', data);

export const updateInvoice = (id, data) =>
  apiClient.put(`/invoices/${id}`, data);

export const deleteInvoice = (id) =>
  apiClient.delete(`/invoices/${id}`);

export const getInvoiceCharges = (invoiceId) =>
  apiClient.get(`/invoices/${invoiceId}/charges`);

export const addInvoiceCharge = (invoiceId, data) =>
  apiClient.post(`/invoices/${invoiceId}/charges`, data);

export const updateInvoiceCharge = (invoiceId, chargeId, data) =>
  apiClient.put(`/invoices/${invoiceId}/charges/${chargeId}`, data);

export const deleteInvoiceCharge = (invoiceId, chargeId) =>
  apiClient.delete(`/invoices/${invoiceId}/charges/${chargeId}`);


// =====================
// Role-Permissions
// =====================

// Get permissions assigned to a role
export const getRolePermissions = (roleId, page = 0, size = 10) =>
  apiClient.get(`/role-permissions`, {
    params: { roleId, page, size }
  });

// Assign multiple permissions to a role
export const assignPermissionsToRole = (roleId, permissions, page = 0, size = 10) =>
  apiClient.post(
    `/role-permissions/assign`,
    {
      role_id: roleId,          // must be plain string UUID
      permissions               // array of { permission_id, scope }
    },
    {
      params: { page, size }
    }
  );

// Remove a permission from a role
export const removePermissionFromRole = (roleId, permissionId, scope = null) =>
  apiClient.delete(`/role-permissions/${roleId}/${permissionId}`, {
    params: scope ? { scope } : {}
  });


// =====================
// Recent Valuations (Dashboard Widget)
// =====================

// Get the 5 most recent valuations – perfect for dashboard
export const getRecentValuations = () =>
  apiClient.get('/recent-valuations/dashboard');

// Get recent valuations with custom limit (optional – for admin pages)
export const getRecentValuationsWithLimit = (limit = 10) =>
  apiClient.get('/recent-valuations', {
    params: { limit }
  });

// Dashboard asset totals by category (record count + total units)
export const getAssetTotalsByCategory = (reviewed = undefined, reviewNotCompleted = undefined, reviewRemarkIssue = undefined) =>
  apiClient.get('/dashboard/asset-totals-by-category', {
    params: {
      ...(reviewed === undefined ? {} : { reviewed }),
      ...(reviewNotCompleted === undefined ? {} : { reviewNotCompleted }),
      ...(reviewRemarkIssue === undefined ? {} : { reviewRemarkIssue }),
    },
  });

export const exportIncompleteAssets = (categoryCode = undefined) =>
  apiClient.get('/assets/public/incomplete/export.xlsx', {
    params: categoryCode ? { categoryCode } : {},
    responseType: 'blob',
  });

export const getBarcodeGenerationStatistics = () =>
  apiClient.get('/dashboard/barcode-generation');

export const getDashboardCaptureTotalsByValuer = () =>
  apiClient.get('/dashboard/capturing-by-valuer');

export const getDashboardReviewTotalsByReviewer = () =>
  apiClient.get('/dashboard/reviewers');


// Asset Departments
export const getAllAssetDepartments = (page = 0, size = 200) =>
  apiClient.get('/asset-departments', { params: { page, size } });

export const createAssetDepartment = ({ name, code }) =>
  apiClient.post('/asset-departments', { name, code });

// Department Status
export const getAssetsByDepartmentStatus = ({ hasDepartment, categoryCode, search, institutionFilter, condition, page = 0, size = 50 } = {}) => {
  const params = { hasDepartment, page, size };
  if (categoryCode) params.categoryCode = categoryCode;
  if (search) params.search = search;
  if (institutionFilter) params.institutionFilter = institutionFilter;
  if (condition) params.condition = condition;
  return apiClient.get('/assets/by-department-status', { params });
};

export const exportAssetsByDepartmentStatus = ({ hasDepartment, categoryCode, search, institutionFilter, condition } = {}) => {
  const params = { hasDepartment };
  if (categoryCode) params.categoryCode = categoryCode;
  if (search) params.search = search;
  if (institutionFilter) params.institutionFilter = institutionFilter;
  if (condition) params.condition = condition;
  return apiClient.get('/assets/department-status-export.csv', { params, responseType: 'blob' });
};

export const bulkUpdateAssetDepartment = ({ assetIds, departmentId }) =>
  apiClient.post('/assets/bulk-update-department', { asset_ids: assetIds, department_id: departmentId });

export const removeAssetDepartment = ({ assetIds }) =>
  apiClient.post('/assets/bulk-remove-department', { asset_ids: assetIds });

export const bulkUpdateInstitutionCategory = ({ assetIds, institutionCategory, institutionCategoryOther }) =>
  apiClient.post('/assets/bulk-update-institution-category', { 
    asset_ids: assetIds, 
    institution_category: institutionCategory,
    institution_category_other: institutionCategoryOther
  });

export const combineAssetInstitution = ({ assetIds, targetInstitutionId }) =>
  apiClient.post('/assets/combine-institution', {
    asset_ids: assetIds,
    target_institution_id: targetInstitutionId,
  });

export const getCombineHistory = () =>
  apiClient.get('/assets/combine-history');

export const getCombineHistoryBatch = (batchId) =>
  apiClient.get(`/assets/combine-history/${batchId}`);

export const revertCombineHistoryBatch = (batchId) =>
  apiClient.post(`/assets/combine-history/${batchId}/revert`);

export const getAssetBarcodes = (assetId) => apiClient.get(`/assets/${assetId}/barcodes`);

// =====================
// Report Summary Management
// =====================

export const getReportSummaryCriteria = () =>
  apiClient.get('/report-summary/criteria');

export const getReportSummaryMethodology = () =>
  apiClient.get('/report-summary/how-it-works');

export const getReportSummaryDryRun = () =>
  apiClient.get('/report-summary/dry-run');

export const getReportSummaryPreview = () =>
  apiClient.get('/report-summary/preview');

export const getReportSummaryMatchedAssets = ({ search, criteriaId, page = 0, size = 50 } = {}) =>
  apiClient.get('/report-summary/assets/matched', {
    params: {
      ...(search ? { search } : {}),
      ...(criteriaId ? { criteriaId } : {}),
      page,
      size,
    },
  });

export const getReportSummaryUnmatchedAssets = ({ search, page = 0, size = 50 } = {}) =>
  apiClient.get('/report-summary/assets/unmatched', {
    params: {
      ...(search ? { search } : {}),
      page,
      size,
    },
  });

export const assignReportSummaryAssets = ({ assetIds, criteriaId, note }) =>
  apiClient.post('/report-summary/assign', {
    asset_ids: assetIds,
    criteria_id: criteriaId,
    note,
  });

export const reassignReportSummaryAssets = ({ assetIds, criteriaId, note }) =>
  apiClient.post('/report-summary/reassign', {
    asset_ids: assetIds,
    criteria_id: criteriaId,
    note,
  });

export const removeReportSummaryAssets = ({ assetIds, note }) =>
  apiClient.post('/report-summary/remove', {
    asset_ids: assetIds,
    note,
  });

export const exportReportSummaryCsv = () =>
  apiClient.get('/report-summary/export.csv', {
    responseType: 'blob',
  });

export const exportReportSummaryXlsx = () =>
  apiClient.get('/report-summary/export.xlsx', {
    responseType: 'blob',
  });
